export default __webpack_public_path__ + "static/media/id.44624bd2.svg";